import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AngularFireDatabase,AngularFireList } from '@angular/fire/database';
import { GlobalVars } from '../../../providers/globalVars';
import { DiscountdetailComponent } from '../../../pages/support/discountdetail/discountdetail.component';
import { ModalController,ToastController,AlertController } from '@ionic/angular';
import { AngularFireAuth } from '@angular/fire/auth';
@Component({
  selector: 'app-discountlist',
  templateUrl: './discountlist.page.html',
  styleUrls: ['./discountlist.page.scss'],
})
export class DiscountlistPage implements OnInit {
chcat:any;
discountlist:any[] = [];
datenow:any = new Date().getTime();
uid:any;
  constructor(private route: ActivatedRoute,public afAuth: AngularFireAuth,public alertCtrl:AlertController,
    public toastCtrl:ToastController, public afDB: AngularFireDatabase,public gv: GlobalVars, public modalCtrl:ModalController) { 
  }

  ngOnInit() {
  
    if(this.gv.uid) {
      this.uid = this.gv.uid;
    }
    else
      this.uid = null;

    this.afDB.database.ref('/discount').limitToLast(20).once('value').then(items=>{
      items.forEach(item=>{let it = item.val(); it.key = item.key; this.discountlist.unshift(it)})}).then(_=>{
        this.discountlist = this.discountlist.map(item=>{
      this.afDB.database.ref(this.gv.getListDir(item.loclancode) + '/' + item.id).once('value').then(
        rst=>item.data = rst.val()
      )
      if(item.ptype == 'zday')
      item.enddiff = Math.ceil((new Date(item.enddate).getTime() - new Date().getTime())/(1000*60*60*24));
      return item;
    })
    })
  
  }
  async discountdetail(list, index) {
    let today = new Date();
    let todaystr = today.getFullYear() + '-' + (today.getMonth()+1>9?today.getMonth()+1:'0' + (today.getMonth()+1)) + '-' + (today.getDate()>9?today.getDate():'0'+today.getDate())
    this.afDB.database.ref('/systemlog/' + (this.uid?this.uid:'unregister') + '/event/' + todaystr + '/event').transaction(view=>{
      return (view || 0) + 1;
    })
    const modal = await this.modalCtrl.create({
      component: DiscountdetailComponent,
      //cssClass: 'ph-custom-modal',
      cssClass: 'eventPopup',
      backdropDismiss: true,
      componentProps: <null>{ 
        list: list,
        index:index
      }
    });
    return await modal.present();
  }

  async deldiscount(key,i){
     let removealert = await this.alertCtrl.create({
            message: '해당 정보를 삭제하시겠습니까?',
            buttons: [
                {
                text: '취소',
                role: 'cancel'
                },
                {
                text: '삭제하기',
                handler: () => {
                    this.afDB.database.ref('/discount/'+key).remove().then(_=>
                    this.presentToast('bottom','삭제하였습니다.', 2200))
                    this.discountlist.splice(i,1);
                }
                }
            ]
            }); 
    removealert.present()
  }
  
  presentToast(position: string,message: string ,duration: number) {
    let toast = this.toastCtrl.create({
      message: message,
      position: 'bottom',
      duration: duration
    });
    toast.then(view=>view.present())
  }
}
